import { modifyMegaMenuTreeData } from "@/helpers/category";
import Link from "next/link";
import ProductCard from "@/components/global/ProductCard";
import { distributeElements } from "@/helpers/chunkArray";
import MenuBanner from "../mega-menu/MenuBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { useRouter } from "next/router";
import useFloatingMenu from "@/hooks/category/useFloatingMenu";

const CategoryList = ({
  children_data,
  parentUrl,
  sku_list,
  banners,
  setOpen,
}) => {
  const { locale } = useRouter();
  const { isShowBanners, isShowProducts, products } = useFloatingMenu({
    sku_list,
    banners,
  });
  const catChunks =
    isShowProducts || isShowBanners
      ? distributeElements(children_data || [], 3)
      : distributeElements(children_data || [], 4);

  return (
    <section className="absolute -top-px start-56 w-[920px]">
      <div className="hidden grid-cols-7 gap-5 py-5 mx-auto text-black bg-white border ms-8 rounded-b-md px-7 group-hover:grid">
        <div
          className={`flex self-start  ${
            isShowProducts || isShowBanners ? "col-span-5" : "col-span-7"
          }`}
        >
          {catChunks?.map((catChunk, idx) => {
            return (
              <div
                key={idx}
                className={`flex flex-col gap-2 mb-2 ${
                  isShowProducts || isShowBanners ? "basis-1/3" : "basis-1/4"
                }`}
              >
                {catChunk?.map((cat) => {
                  const childUrl = `/${parentUrl}/${cat?.url_key}`;
                  const modifiedData = modifyMegaMenuTreeData(
                    cat?.children_data
                  );

                  return (
                    <div key={cat?.id}>
                      <Link
                        onClick={() => setOpen(false)}
                        className="mb-3 font-bold "
                        href={childUrl.replace("//", "/")}
                        prefetch={false}
                      >
                        {cat?.name}
                      </Link>
                      <ul className="flex flex-col gap-2">
                        {modifiedData?.length > 0 &&
                          modifiedData.map((subCat) => {
                            const subChildUrl = `/${childUrl}/${subCat?.url_key}`;

                            return (
                              <li
                                key={subCat?.id}
                                className="font-medium transition-all duration-500 cursor-pointer hover:text-primary-800"
                              >
                                <Link
                                  onClick={() => setOpen(false)}
                                  prefetch={false}
                                  href={subChildUrl.replace("//", "/")}
                                >
                                  {subCat?.name}
                                </Link>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>

        {isShowProducts && (
          <div className="col-span-2 gap-3">
            <Swiper
              modules={[Pagination, Autoplay]}
              loop
              key={locale}
              dir={locale === "en" ? "rtl" : "ltr"}
              pagination={{ clickable: true }}
              className={`banner-category__list`}
            >
              {products?.map((product, idx) => (
                <SwiperSlide key={idx}>
                  <div className="mb-5">
                    <ProductCard product={product} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}

        {isShowBanners && (
          <div className="flex flex-col col-span-2 gap-3">
            <MenuBanner {...banners[0]} />
            <MenuBanner {...banners[1]} />
          </div>
        )}
      </div>
    </section>
  );
};

export default CategoryList;
